<template>
  <!-- 账户绑定 -->
  <div>
    <h3>{{ $t('myAccount.menu[2]') }}</h3>
    <a-row type="flex" justify="space-around" class="sec_item" v-for="(item, index) in secList" :key="index">
      <a-col :span="6" class="sec_title">{{ item.title }}</a-col>
      <a-col :span="12"></a-col>
      <!-- 已绑定 -->
      <a-col :span="6" class="sec_btn" v-if="item.key">
        <span class="bold_color"><b-icon type="iconwanchengrenwu"></b-icon>{{ $t('myAccount.securState[2]') }}</span>
        <a-divider type="vertical" />
        <span class="bule_color" @click="onUnBind(item.type)">{{ $t('myAccount.securState[3]') }}</span>
      </a-col>
      <a-col :span="6" class="sec_btn" v-else>
        <span class="red_color"><b-icon type="iconweibangding1"></b-icon>{{ $t('myAccount.securState[4]') }}</span>
        <a-divider type="vertical" />
        <span class="bule_color" @click="toBind(item.type)">{{ $t('myAccount.securState[5]') }}</span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { apiMy } from '@/api/my'
import AES from '@/utils/aes'

export default {
  computed: {
    ...mapGetters(['userInfo']),
    secList () {
      const info = JSON.parse(this.userInfo || '{}')
      // type 钉钉: 1, 微信： 2
      const list = [
        {
          title: this.$t('myAccount.accountList[0]'),
          key: info.wechatId,
          type: 2
        },
        {
          title: this.$t('myAccount.accountList[1]'),
          key: info.dingId,
          type: 1
        }
      ]
      return list
    }
  },
  methods: {
    /**
     * 绑定
     */
    toBind (type) {
      const linkType = type === 1 ? 2 : 1
      // type 1：微信， 2：钉钉
      if (linkType === 1) {
        const _url = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + process.env.VUE_APP_WECHAT_APPID +
        '&scope=snsapi_login' +
        '&redirect_uri=' + encodeURIComponent(`${process.env.VUE_APP_LOGIN_REDIRECT_WECHAT_URI}?token=${AES.Decrypt(this.$cookies.get('access_token'))}&callback=${location.href}`) +
        '&state=saas_wechat_bind&login_type=jssdk&self_redirect=default&style=black'
        // window.open(_url, '_blank')
        window.location.href = _url
      } else {
        const _url = 'https://oapi.dingtalk.com/connect/qrconnect?appid=' + process.env.VUE_APP_DINGTALK_APPID +
          '&response_type=code&scope=snsapi_login' +
          '&redirect_uri=' + encodeURIComponent(`${process.env.VUE_APP_LOGIN_REDIRECT_WECHAT_URI}?token=${AES.Decrypt(this.$cookies.get('access_token'))}&callback=${location.href}`) +
          '&state=saas_ding_bind&login_type=jssdk&self_redirect=default&style=black'
        // window.open(_url, '_blank')
        window.location.href = _url
      }
    },
    /**
     * 解绑
     */
    onUnBind (type) {
      const _this = this
      this.$confirm({
        title: this.$t('operation.tip'),
        content: this.$t('myAccount.isBind'),
        okType: 'danger',
        onOk () {
          return new Promise((resolve, reject) => {
            apiMy.unbind(type).then(data => {
              _this.$message.success(_this.$t('msg.bindOk'))
              _this.$store.dispatch('getUserInfo', `${_this.$config.userInfoUri}?token=${_this.$token.loadToken().access_token}`)
              resolve()
            }).catch(() => {
              resolve()
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
h3 {
  font-weight: bold;
  padding: 10px 0;
}
.sec_item {
  border-bottom: 1px solid #eee;
  padding: 25px 0;
  .sec_title {
    font-weight: bold;
  }
  .bule_color {
    color: #4977FC;
    cursor: pointer;
  }
  .bold_color {
    color: #52C41A;
  }
  .red_color {
    color: #F5222D;
  }
  .sec_btn {
    text-align: right;
  }
}
</style>
